import React from "react";
import { PrivateProsecution, PrivateProsecutionFeedback } from "types";
import { feedbackIcon } from "utils/constant";

type Props = {
  privateProsecution: PrivateProsecution;
  feedbacks: PrivateProsecutionFeedback[];
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
};

const PrivateProsecutionFeedbackSection: React.FC<Props> = ({
  privateProsecution,
  feedbacks,
  setRefetch,
}) => {
  return (
    <div>
      <h1 className="text-black font-semibold text-lg flex flex-row gap-2 items-center mb-2">
        <span className="text-[#AA232F] text-xl">{feedbackIcon}</span>
        <span className="tracking-wide">Feedback Section</span>
      </h1>
      <div className="flex flex-col gap-4 mt-2 justify-between h-[70vh] w-full">
        <div className="flex flex-col overflow-y-auto gap-3 pr-1">
          {feedbacks && feedbacks.length > 0 ? (
            feedbacks?.map((feedback, index) => (
              <div
                key={index}
                className={`flex flex-row items-start gap-3 rounded-lg shadow-sm border border-gray-200 px-4 py-3 ${
                  index % 2 === 0 ? "bg-[#F7F7F7]" : "bg-white"
                }`}
                style={{ overflowWrap: "break-word" }}
              >
                {/* Feedback type icon */}
                <div className="flex-1">
                  <p className="text-sm text-gray-700 leading-relaxed mb-1">
                    {feedback?.feedback_text}
                  </p>
                  <p className="text-xs text-red-500">{feedback?.created_by}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-800 py-8">
              No feedback yet.
            </div>
          )}
        </div>

        {/* {isCoordinator && (
          <div
            style={{ boxShadow: "rgb(217 217 217 / 90%) 0px -6px 7px 0px" }}
            className="px-6 py-4 w-full bg-white rounded-lg border border-gray-200 mt-2"
          >
            <p className="font-semibold text-[#AA232F] mb-2">
            </p>
            <div className="flex flex-col mt-2">
              <textarea
                rows={4}
                className="w-full bg-[#F2F2F2] px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#AA232F] text-sm resize-none"
                placeholder="Write your feedback here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
              <div className="text-right mt-2">
                <button
                  className="px-5 py-2 rounded-full bg-[#AA232F] text-white text-xs font-semibold shadow hover:bg-[#E90101] transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-[#AA232F]"
                  onClick={() => {
                    if (!newComment.trim()) {
                      showTooltip(t("please_enter_a_comment"), "error");
                      return;
                    }

                    addPrivateProsecutionFeedback({
                      feedback_text: newComment,
                      created_by: loginData?.full_name,
                      private_prosecution: privateProsecution?.id || null,
                    })
                      .then(() => {
                        setNewComment("");
                        setRefetch((prev: any) => !prev);
                        showTooltip(t("comment_added_successfully"), "success");
                      })
                      .catch((error) => {
                        showTooltip(
                          errorHandlerOnForm(error) || "Error adding comment:",
                          "error",
                        );
                      });
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default PrivateProsecutionFeedbackSection;
